export enum ENotificationTypes {
  DUPLICATE_RESIDENT_WARNING = 'DUPLICATE_RESIDENT_WARNING',
  INSURANCE_ADDED = 'INSURANCE_ADDED',
  NEW_RESIDENT = 'NEW_RESIDENT',
  CONSENT_SUBMITTED = 'CONSENT_SUBMITTED',
  INSURANCE_INVALID = 'INSURANCE_INVALID',
  CONSENT_INVALID = 'CONSENT_INVALID',
  RESIDENT_NOT_FOUND = 'RESIDENT_NOT_FOUND',
}
